export const socialTypes = [
  'reddit',
  'twitter',
  'facebook',
  'youtube',
  'medium',
  'telegram',
  'discord',
]
